import * as angular from 'angular';
import security from '../../../service/security/security-services';
import contractService from '../../../service/contract/contract-services';
import server from '../../../integration/server/server-services';
import {ContractMilestone} from "../../../integration/representation/contract";

export default function ContractHomeController($q: angular.IQService,
                                               $routeParams: angular.route.IRouteParamsService,
                                               $filter: angular.IFilterService,
                                               security: security,
                                               contract: contractService,
                                               server: server) {
    const vm = this;

    vm.contract = contract;
    vm.approveMilestone = approveMilestone;
    vm.completenessItems = undefined;
    vm.canApprove = false;
    vm.showMissingFeatureTypes = false;
    vm.showMissingFKBFeatureTypes = false;
    vm.featureList = undefined;
    vm.loadingFeatureList = true;
    vm.loadingCompletenessItems = true;

    vm.toggleMissingFeatureTypes = toggleMissingFeatureTypes;
    vm.toggleMissingFKBFeatureTypes = toggleMissingFKBFeatureTypes;

    function approveMilestone(milestone: ContractMilestone) {
        milestone.approved = true;
        vm.contract.saveMilestone({
            id: milestone.id,
            approved: milestone.approved,
            deadline: toDateString(milestone.deadline),
            name: milestone.name,
            description: milestone.description
        });
    }

    function toDateString(date: string) {
        return $filter('date')(date, 'yyyy-MM-dd');
    }

    function toggleMissingFeatureTypes() {
        vm.showMissingFeatureTypes = !vm.showMissingFeatureTypes;
    }

    function toggleMissingFKBFeatureTypes() {
        vm.showMissingFKBFeatureTypes = !vm.showMissingFKBFeatureTypes;
    }

    function init() {
        security.ensureCurrentUser().then(function(user) {
            vm.user = user;
            vm.canApprove = vm.user.hasPermission('MILESTONE:UPDATE', $routeParams.contractId);
        });

        $q.all([
            contract.selectContract($routeParams.contractId),
            server.readContractCompleteness($routeParams.contractId)
        ]).then(function(data) {
            vm.contract = data[0];
            vm.completenessItems = data[1];
            vm.loadingCompletenessItems = false;

            return $q.all([
                contract.readFeatureList(),
                contract.readFKBFeatureList()
            ]);
        })
            .then(function(featureLists) {
                vm.featureList = featureLists[0];
                vm.fkbFeatureList = featureLists[1];
                vm.loadingFeatureList = false;
            })
            .catch(function(error) {
                vm.loadingFeatureList = false;
                vm.loadingCompletenessItems = false;
            });
    }

    init();
}

ContractHomeController.$inject = ['$q', '$routeParams', '$filter', 'security', 'contract', 'server'];
